/// <amd-module name="TFS/CreateProject/Models" />
import {
    IOptionItem,
    IProcessTemplateDescriptor,
    IProjectCreationMetadata,
    IProjectCreationMetadataItemDescriptor,
    StatusMessageType,
    StatusType,
    StatusValueType
} from "TFS/CreateProject/Contracts";

export interface ICreateProjectComponentState {
    navigationUrl: string;
    projectCreationMetadata: IProjectCreationMetadata;
    existingProjectNames: { [key: string]: boolean };
    featureIds: string[] | undefined;
    projectNameState: IProjectNameState;
    projectParamsState: IProjectParamsState;
    projectLimitState: IProjectLimitState;
    creationStatus: IStatus;
    pageStatus: IStatus;
    source: string;
    showAdvancedOptions: boolean;
    statusMessage: IStatusMessage;
}

export interface IProjectNameState {
    name: string;
    status: IStatus;
}

export interface IProjectLimitState {
    isBelowLimit: boolean;
    isBelowWarning: boolean;
    status: IStatus;
}

export interface IProjectParamsState {
    projectDescription: string;
    projectVisibilityOptions: IOptionItem[];
    currentVersionControlType: string;
    currentProjectVisibilityOption: IProjectCreationMetadataItemDescriptor;
    currentProcessTemplateId: string;
    currentProcessTemplateName: string;
}

export interface IStatusMessage {
    message: string;
    statusMessageType: StatusMessageType;
    showTryAgainCta: boolean;
    showGoBackCta: boolean;
    operationLogsLink?: string;
}

export interface IStatus {
    statusType: StatusType;
    value: StatusValueType;
    message: string;
    detailedMessage?: string;
    creationOperationId?: string;
}
